export enum Operator {
  Equals = 'equals',
  NotEquals = 'not_equals',
  Contains = 'contains',
  NotContains = 'not_contains',
  StartsWith = 'starts_with',
  EndsWith = 'ends_with',
  IsEmpty = 'empty',
  IsNotEmpty = 'not_empty',
  RegexMatch = 'regex_match',
  GreaterThan = 'gt',
  GreaterThanOrEqualTo = 'gte',
  LessThan = 'lt',
  LessThanOrEqualTo = 'lte',
  Between = 'between',
  In = 'in',
  NotIn = 'not_in',
  Exists = 'exists',
  NotExists = 'not_exists',
  Before = 'before',
  After = 'after',
  LastX = 'last',
  HasBeenPerformed = 'performed',
  HasNotBeenPerformed = 'not_performed',
  HasBeenPerformedInPeriod = 'performed_in_period',
}
